import clsx from 'clsx'

import { DistrictAncestorsResponse } from '@/apis/types'

import { Breadcrumbs } from '@/components/Breadcrumbs'
import { Container } from '@/components/Container'

import { DATA_INDUK_ROUTE } from '@/configs/constants'

import { ancestorToBreadcrumb } from '../helpers'

export const NavSection = ({
  isPending,
  withRoot = false,
  level,
  prefixPath = DATA_INDUK_ROUTE,
  data,
  className = '',
}: {
  isPending: boolean
  withRoot?: boolean
  level: number
  prefixPath?: string
  data?: DistrictAncestorsResponse
  className?: string
}) => {
  return (
    <section id="nav-section" className={clsx('bg-gray-5', className)}>
      <Container>
        <Breadcrumbs
          items={
            isPending
              ? []
              : ancestorToBreadcrumb({
                  level: level,
                  withRoot: withRoot,
                  pathPrefix: prefixPath,
                  nestedDistrict: data?.district || null,
                })
          }
        />
      </Container>
    </section>
  )
}
